import React, { useEffect, useState } from 'react';
import styles from './ProductDetails.module.css';
import { BsHeart, BsShare, BsPlus, BsHeartFill, } from "react-icons/bs";
import { BiMinus, BiLink } from 'react-icons/bi';
import { Helmet } from "react-helmet";
import { toast } from 'react-toastify';

import api from '../../api/api';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, Link, useParams, useLocation } from 'react-router-dom';
import Cookies from 'universal-cookie';
import Slider from 'react-slick';
import { AiOutlineEye } from 'react-icons/ai';
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import { FacebookIcon, TelegramIcon, WhatsappIcon, } from 'react-share';
import QuickViewModal from './QuickViewModal';
import { IoIosArrowDown } from 'react-icons/io';
import { useTranslation } from 'react-i18next';
import Loader from '../loader/Loader';
import { clearSelectedProduct, setSelectedProduct } from '../../model/reducer/selectedProduct';
import { setCart, setCartProducts, setCartSubTotal, setSellerFlag } from '../../model/reducer/cartReducer';
import { setFavouriteLength, setFavouriteProductIds } from '../../model/reducer/favouriteReducer';
import Popup from '../same-seller-popup/Popup';
import useGetProductRatingsById from '../../hooks/useGetProductRatingsById';
import { OverlayTrigger, Popover, ProgressBar } from 'react-bootstrap';
import ProductDetailsTabs from './ProductDetailsTabs';
import StarFilledSVG from "../../utils/StarFilled.svg";
import useGetProductRatingImages from '../../hooks/useGetProductRatingImages';
import { LuStar } from 'react-icons/lu';
import VegIcon from "../../utils/Icons/VegIcon.svg";
import NonVegIcon from "../../utils/Icons/NonVegIcon.svg";
import NonCancelable from "../../utils/Icons/NotCancelable.svg";
import Cancelable from "../../utils/Icons/Cancelable.svg";
import Returnable from "../../utils/Icons/Returnable.svg";
import NotReturnable from "../../utils/Icons/NotReturnable.svg";
import ReactPlayer from 'react-player';
import ReactImageMagnify from 'react-image-magnify';
import { setFilterBrands } from '../../model/reducer/productFilterReducer';
import { setCurrentImage } from '../../model/reducer/categoryImage';
import { setProductBuyNow } from '../../model/reducer/productBuyNowReducer';
import { EnvironmentOutlined } from "@ant-design/icons";
import { Input, Row, Col, Button } from 'antd';
import { Modal, Radio } from "antd";
import { useRef } from 'react';


import ImageQuickViewModal from './ImageQuickView';

const ProductDetails = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const cookies = new Cookies();
    const { slug } = useParams();
    const location = useLocation();


    const product = useSelector(state => state.selectedProduct);
    const cart = useSelector(state => state.cart);
    const city = useSelector(state => state.city);
    const setting = useSelector(state => state.setting);
    const favorite = useSelector(state => (state.favourite));
    const shop = useSelector(state => state.shop);
    const user = useSelector(state => state.user);
    // const buyNow = useSelector(state => state.buyNow);

    const [canonicalUrl, setCanonicalUrl] = useState('');
    useEffect(() => {
        window.scrollTo({ top: 0 });
        return () => {
            dispatch(clearSelectedProduct({ data: null }));
            setproductcategory({});
        };
    }, []);

    const [mainimage, setmainimage] = useState("");
    const [videourl, setvideourl] = useState("");
    const [images, setimages] = useState([]);
    const [productdata, setproductdata] = useState({});
    const [productSize, setproductSize] = useState({});
    const [productcategory, setproductcategory] = useState({});
    const [relatedProducts, setrelatedProducts] = useState(null);
    const [loading, setisLoading] = useState(false);
    const [quantity, setQuantity] = useState([]);
    const [relatedItemQuantity, setRelatedItemQuantity] = useState({});
    const uniqueImages = [...new Set(images)];

    const [selectedVariant, setSelectedVariant] = useState(null);
    const [selectedItemSize, setSelectedItemSize] = useState({});
    const [selectedProduct, setselectedProduct] = useState({});
    // const [productSizes, setproductSizes] = useState(null);
    // const [offerConatiner, setOfferContainer] = useState(0);
    const [variant_index, setVariantIndex] = useState(null);
    // const [realted_variant_index, setRelatedVariantIndex] = useState(0);
    const [showModal, setShowModal] = useState(false);
    const [imageShowModal, setImageShowModal] = useState(false);

    const [p_id, setP_id] = useState(0);
    const [p_v_id, setP_V_id] = useState(0);
    const [qnty, setQnty] = useState(0);
    const [cartLoader, setCartLoader] = useState(false);
    const [ProductCategoryList, setProductCategoryList] = useState([]);
    const [show, setShow] = useState(false);
    const [pincode, setPincode] = useState("");
    const inputRef = useRef(null);
    const [pincodetext, SetPincodetext] = useState("");
    const [pageSize, setPageSize] = useState('lg');
    const [showDropdown, setShowDropdown] = useState({});





    // const getCategoryDetails = (id) => {
    //     api.getCategory()
    //         .then(response => response.json())
    //         .then(result => {
    //             if (result.status === 1) {

    //                 result.data.forEach(ctg => {
    //                     if (ctg.id === id) {
    //                         setproductcategory(ctg);
    //                     }
    //                 });
    //             }
    //         })
    //         .catch((error) => console.log(error));
    // };

    // Not Used
    // const getBrandDetails = (id) => {
    //     api.getBrands()
    //         .then(response => response.json())
    //         .then(result => {
    //             if (result.status === 1) {

    //                 result.data.forEach(brnd => {
    //                     if (brnd.id === id) {
    //                         console.log(brnd);
    //                         setproductbrand(brnd);
    //                     }
    //                 });
    //             }
    //         })
    //         .catch((error) => console.log(error));
    // };
    const onClickBuyNow = (product) => {
        dispatch(setProductBuyNow({
            variantId: product.variants[0].id,
            subTotal: product,
            totalPayment: product.variants[0].discounted_price
        })
        )
        navigate('/checkout')
    }
    const goBack = () => {
        navigate('/')
    }

    const getProductDatafromApi = (slug) => {
        const latitude = setting?.setting?.default_city?.latitude ? setting?.setting?.default_city?.latitude : city.city?.latitude;
        const longitude = setting?.setting?.default_city?.longitude ? setting?.setting?.default_city?.longitude : city.city?.longitude;

        if ((slug !== null || slug !== undefined) && (latitude && longitude)) {
            api.getProductbyId(latitude, longitude, -1, localStorage.getItem('jwt_token'), slug)
                .then(response => response.json())
                .then(result => {
                    if (result.status === 1) {
                        dispatch(setSelectedProduct({ data: result?.data[0]?.id }));
                        setproductdata(result.data);
                        setVariantIndex(result.data.variants[0]?.id);
                        setSelectedVariant(result.data.variants?.length > 0 && result.data.variants.find((element) => element.id == variant_index) ? result.data.variants.find((element) => element.id == variant_index) : result.data.variants[0]);
                        setmainimage(result.data.image_url);
                        setmainimage(result.data.image_url);
                        setvideourl(result.data.video ? result.data.video : '');
                        setimages(result.data.images);
                        setProductCategoryList(result.data.category_list);
                        handleClear();
                    };
                })
                .catch(error => console.log(error));
        } else {
            return;
        }


    };




    useEffect(() => {

        getProductDatafromApi(slug);
    }, [slug, setting?.setting?.default_city?.latitude, setting?.setting?.default_city?.longitude]);

    const fetchRelatedProducts = () => {
        api.getProductbyFilter(
            city.city?.latitude ? city.city?.latitude : setting?.setting?.default_city?.latitude,
            city.city?.longitude ? city.city?.longitude : setting?.setting?.default_city?.longitude,
            {
                category_id: productdata.category_id,
            },
            localStorage.getItem('jwt_token')
        )
            .then(response => response.json())
            .then(result => {
                if (result.status === 1) {
                    // Filter out the current product from the related products
                    const filteredRelatedProducts = result.data.filter(product => product.id !== productdata.id);
                    setproductSize(result.sizes);
                    setrelatedProducts(filteredRelatedProducts);
                }
            })
            .catch(error => console.log(error));
    };

    useEffect(() => {
        if (Object.keys(productdata).length !== 0) {
            fetchRelatedProducts();
        }
        if (productdata && selectedVariant === null && productdata.variants) {
            setSelectedVariant(productdata.variants[0]);
        }
    }, [productdata]);

    useEffect(() => {
        getProductDatafromApi();
    }, [cart]);



    const CustomPrevButton = ({ currentSlide, slideCount, ...props }) => (
        <button {...props} type="button" className={`${styles.slickprev}  slick-prev`}>
            <FaChevronLeft fill='black' size={30} className={styles.prevarrow} />
        </button>
    );
    const CustomNextButton = ({ currentSlide, slideCount, ...props }) => (
        <button {...props} type="button" className={`${styles.slicknext}`}>
            <FaChevronRight fill='black' size={30} className={styles.nextarrow} />
        </button>
    );
    const settings = {
        infinite: false,
        slidesToShow: 6,
        initialSlide: 0,
        prevArrow:
            <CustomPrevButton />,

        nextArrow:
            <CustomNextButton />,

        responsive: [
            {
                breakpoint: 1199,
                settings: {
                    slidesToShow: 4,
                }
            },
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 4,
                }
            },
            {
                breakpoint: 425,
                settings: {
                    slidesToShow: 2,
                    arrows: true,
                }
            }
        ]
    };

    const settings_subImage = {
        infinite: true,
        slidesToShow: Math.min(5, images.length),
        slidesToScroll: 1,
        initialSlide: 0,
        arrows: images.length > 5,
        prevArrow: (
            <button type="button" className={styles.slickprev1}>
                <FaChevronLeft fill='black' size={30} className={styles.prevarrow1} />
            </button>
        ),
        nextArrow: (
            <button type="button" className={styles.slicknext1}>
                <FaChevronRight fill='black' size={30} className={styles.nextarrow1} />
            </button>
        ),
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: Math.min(5, images.length),
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: Math.min(4, images.length),
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 425,
                settings: {
                    slidesToShow: Math.min(3, images.length),
                    slidesToScroll: 1,
                }
            }

        ],
    };


    const [limit, setLimit] = useState(12);
    const [offset, setOffset] = useState(0);
    const { productRating, totalData, loading: Loading, error } = useGetProductRatingsById(localStorage.getItem("jwt_token"), productdata?.id, limit, offset);
    const { ratingImages, totalImages } = useGetProductRatingImages(localStorage.getItem("jwt_token"), productdata?.id, 8, offset);

    // useEffect(() => {
    //     if (productdata && selectedVariant === null && productdata.variants) {
    //         setSelectedVariant(productdata.variants[0]);
    //     }

    // }, [productdata, cart]);

    //Add to Cart
    const addtoCart = async (product_id, product_variant_id, qty) => {
        setP_id(product_id);
        setP_V_id(product_variant_id);
        setQnty(qty);

        if (!user?.user) {
            document.getElementById("user-profile").click();
        }
        await api
            .addToCart(localStorage.getItem("jwt_token"), product_id, product_variant_id, qty)
            .then((response) => response.json())
            .then(async (result) => {
                if (result.status === 1) {
                    // toast.success(result.message);
                    if (cart?.cartProducts?.find(
                        (product) =>
                            product?.product_id === product_id &&
                            product?.product_variant_id === product_variant_id
                    )?.qty === undefined
                    ) {
                        dispatch(setCart({ data: result }));
                        dispatch(setCartSubTotal({ data: result?.data?.sub_total }));
                        const updatedCartCount = [
                            ...cart?.cartProducts,
                            {
                                product_id: product_id,
                                product_variant_id: product_variant_id,
                                qty: qty,
                            },
                        ];
                        dispatch(setCartProducts({ data: updatedCartCount }));
                    } else {
                        const updatedProducts = cart?.cartProducts?.map((product) => {
                            if (
                                product.product_id === product_id &&
                                product?.product_variant_id === product_variant_id
                            ) {
                                return { ...product, qty: qty };
                            } else {
                                return product;
                            }
                        });
                        dispatch(setCart({ data: result }));
                        dispatch(setCartProducts({ data: updatedProducts }));
                        dispatch(setCartSubTotal({ data: result?.data?.sub_total }));
                    }
                } else if (result?.data?.one_seller_error_code === 1) {
                    dispatch(setSellerFlag({ data: 1 }));
                }
            });
    };

    //remove from Cart
    const removefromCart = async (product_id, product_variant_id) => {
        setisLoading(true);
        await api.removeFromCart(localStorage.getItem('jwt_token'), product_id, product_variant_id)
            .then(response => response.json())
            .then(async (result) => {
                if (result.status === 1) {
                    toast.success(result.message, { hideProgressBar: true, autoClose: 1000 });
                    dispatch(setCartSubTotal({ data: result?.sub_total }));
                    const updatedCartProducts = cart?.cartProducts?.filter(product => {
                        if (product?.product_variant_id != product_variant_id) {
                            return product;
                        }
                    });
                    dispatch(setCartProducts({ data: updatedCartProducts ? updatedCartProducts : [] }));
                }
                else {
                    toast.error(result.message, { hideProgressBar: true, autoClose: 1000 });
                }
                setisLoading(false);
            });
    };

    const handleShareClick = (platform) => {
        const shareUrl = `${setting.setting && setting.setting.web_settings.website_url}/product/${productdata.slug}`;
        let redirectUrl = "";
        const isDesktop = window.innerWidth > 768;
        switch (platform) {
            case "whatsapp":
                redirectUrl = isDesktop
                    ? `https://web.whatsapp.com/send?text=${encodeURIComponent(shareUrl)}`
                    : `https://api.whatsapp.com/send?text=${encodeURIComponent(shareUrl)}`;
                break;
            case "telegram":
                redirectUrl = `https://t.me/share/url?url=${encodeURIComponent(shareUrl)}`;
                break;
            case "facebook":
                redirectUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl)}`;
                break;
            default:
                return;
        }
        window.open(redirectUrl, "_blank", "noopener,noreferrer");
    };

    //Add to favorite
    const addToFavorite = async (product_id) => {
        if (!user?.user) {
            document.getElementById("user-profile").click();
        } else {
            // setisLoading(true);
            await api.addToFavotite(localStorage.getItem('jwt_token'), product_id)
                .then(response => response.json())
                .then(async (result) => {
                    if (result.status === 1) {
                        toast.success(result.message, { hideProgressBar: true, autoClose: 1000 });
                        const updatedFavouriteProducts = [...favorite.favouriteProductIds, product_id];
                        dispatch(setFavouriteProductIds({ data: updatedFavouriteProducts }));
                        const updatedFavouriteLength = favorite?.favouritelength + 1;
                        dispatch(setFavouriteLength({ data: updatedFavouriteLength }));
                    }
                    else {
                        toast.error(result.message, { hideProgressBar: true, autoClose: 1000 });
                    }
                    // setisLoading(false);
                });
        }
    };

    const removefromFavorite = async (product_id) => {
        // setisLoading(true);
        await api.removeFromFavorite(localStorage.getItem('jwt_token'), product_id)
            .then(response => response.json())
            .then(async (result) => {
                if (result.status === 1) {
                    toast.success(result.message, { hideProgressBar: true, autoClose: 1000 });
                    const updatedFavouriteProducts = favorite?.favouriteProductIds.filter(id => id != product_id);
                    dispatch(setFavouriteProductIds({ data: updatedFavouriteProducts }));
                    const updatedFavouriteLength = favorite?.favouritelength - 1;
                    dispatch(setFavouriteLength({ data: updatedFavouriteLength }));
                }
                else {
                    toast.error(result.message, { hideProgressBar: true, autoClose: 1000 });
                }
                // setisLoading(false);
            });
    };

    // useEffect(() => {
    //     if (productdata.length > 0) {
    //         setSelectedVariant(productdata.varaints[0]);
    //     }
    // }, [productdata, cart]);

    // useEffect(() => {
    // window.scrollTo({ top: 0, behavior: 'smooth' });
    // }, [productdata]);

    const handleVariantChange = (variant, index) => {
        setSelectedVariant(variant);
        setVariantIndex(index);
    };

    const { t } = useTranslation();

    const placeHolderImage = (e) => {
        e.target.src = setting.setting?.web_logo;
    };

    const calculatePercentage = (totalRating, starWiseRating) => {
        const percentage = (starWiseRating * 100) / totalRating;
        return percentage;
    };

    const popover = (
        <Popover>
            <Popover.Body className={styles.ratingPopOverBody}>
                <div className={`d-flex flex-row justify-content-start align-items-center ${styles.ratingCircleContainer}`}>
                    <div className={styles.ratingCircle} style={{ fontWeight: 'bold' }}>
                        {productRating?.average_rating?.toFixed(2)}
                    </div>
                    <div className='d-flex justify-content-center align-items-center' style={{ marginLeft: '146px', marginBottom: '1px', fontWeight: 'bold' }}>
                        <div className='fw-bold me-2'> {/* Add margin to the right for spacing */}
                            {totalData}
                        </div>
                        <div style={{ marginLeft: '2px', marginTop: '1px', marginRight: '-6px', fontWeight: 'bold' }}>
                            {t("Ratings")}
                        </div>


                    </div>
                </div>
                <div className='d-flex justify-content-start align-items-center gap-4'>
                    {t("5")}
                    <div className='d-flex gap-1'>
                        <img src={StarFilledSVG} alt='starLogo' loading='lazy' />
                    </div>
                    <ProgressBar now={Math.floor(calculatePercentage(totalData, productRating?.five_star_rating))} className={styles.ratingBar} />
                    <div>
                        {productRating?.five_star_rating}
                    </div>
                </div>
                <div className='d-flex justify-content-start align-items-center mt-3 gap-4'>
                    {t("4")}
                    <div className='d-flex gap-1'>
                        <img src={StarFilledSVG} alt='starLogo' loading='lazy' />
                    </div>
                    <ProgressBar now={Math.floor(calculatePercentage(totalData, productRating?.four_star_rating))} className={styles.ratingBar} />
                    <div>
                        {productRating?.four_star_rating}
                    </div>
                </div>
                <div className='d-flex justify-content-start align-items-center mt-3 gap-4'>
                    {t("3")}
                    <div className='d-flex gap-1'>
                        <img src={StarFilledSVG} alt='starLogo' loading='lazy' />
                    </div>
                    <ProgressBar now={Math.floor(calculatePercentage(totalData, productRating?.three_star_rating))} className={styles.ratingBar} />
                    <div>{productRating?.three_star_rating}</div>
                </div>
                <div className='d-flex justify-content-start align-items-center mt-3 gap-4'>
                    {t("2")}
                    <div className='d-flex gap-1'>
                        <img src={StarFilledSVG} alt='starLogo' loading='lazy' />
                    </div>
                    <ProgressBar now={Math.floor(calculatePercentage(totalData, productRating?.two_star_rating))} className={styles.ratingBar} />
                    <div>{productRating?.two_star_rating}</div>
                </div>
                <div className='d-flex justify-content-start align-items-center mt-3 gap-4'>
                    {t("1")}
                    <div className='d-flex gap-1'>
                        <img src={StarFilledSVG} alt='starLogo' loading='lazy' />
                    </div>
                    <ProgressBar now={Math.floor(calculatePercentage(totalData, productRating?.one_star_rating))} className={styles.ratingBar} />
                    <div>{productRating?.one_star_rating}</div>
                </div>
            </Popover.Body>
        </Popover>
    );

    function getProductQuantities(products) {
        return Object.entries(products.reduce((quantities, product) => {
            const existingQty = quantities[product.product_id] || 0;
            return { ...quantities, [product.product_id]: existingQty + product.qty };
        }, {})).map(([productId, qty]) => ({
            product_id: parseInt(productId),
            qty
        }));
    }

    const truncateBrandName = (brandName) => {
        const words = brandName?.split(" ");
        return words?.length > 2 ? words?.slice(0, 2).join(" ") + "..." : brandName;
    };

    const onClickBrand = (e, product) => {
        e.stopPropagation();
        dispatch(setFilterBrands({ data: product.id.toString() }));
        navigate(`/brands/${product.slug}`, { replace: true });
    }

    const onClickDetailsBrand = (product) => {
        dispatch(setFilterBrands({ data: product.id.toString() }));
        navigate(`/brands/${product.brand_slug}`, { replace: true });
    }

    const onClickBreadCrum = (cat) => {
        dispatch(setCurrentImage({ image: cat.image_url, categoryName: cat.name }));
        navigate(`/category/${cat?.slug}`, { replace: true });
    };


    const CheckDeliveryTime = async (pincode, product_id) => {
        try {
            setCartLoader(true);

            const response = await api.CheckDeliveryTime(pincode, product_id);

            if (!response.ok) {
                throw new Error(`HTTP Error: ${response.status}`);
            }

            const result = await response.json();
            SetPincodetext(result.date);
        } catch (error) {
            SetPincodetext("Delivery time check failed.");
        } finally {
            setCartLoader(false);
        }
    };

    const handleClear = () => {
        setPincode("");
        SetPincodetext("");
    }

    const handleChange = (e) => {
        const value = e.target.value;
        if (/^\d*$/.test(value) && value.length <= 6) {
            setPincode(value);
        }
        if (!value) {
            handleClear();
        }
    };

    const onClickCheck = () => {
        if (!pincode) {
            inputRef.current?.focus();
        } else {
            CheckDeliveryTime(pincode, productdata?.seller_id);
        }
    };

    const handleImageClick = (related_product) => {
        setImageShowModal(true);
        setselectedProduct(related_product);
        setP_id(related_product.id);
        setP_V_id(related_product.variants[0].id);
        setQnty(related_product.variants[0].cart_count + 1);
    }


    useEffect(() => {
        const link = document.querySelector("link[rel='canonical']");
        if (link) {
            link.href = `https://www.myacebazar.com${window.location.pathname}`
        }
        return () => link.href = `https://www.myacebazar.com${window.location.pathname}`
    }, [window.location.pathname]);

    return (
        <>
            {loading && <Loader screen="full" background="none" />}
            {productdata && (

                <Helmet>
                    <title>{productdata?.name || 'E-Commerce'}</title>
                    <meta
                        name="description"
                        content={`Explore ${productdata?.name || 'Product'} - ${productdata?.description || 'A high-quality product'}`}
                    />
                    <meta
                        name="keywords"
                        content={`${productdata?.name || ''}, ${Array.isArray(productdata?.category_list)
                            ? productdata.category_list.map((cat) => cat.name).join(', ')
                            : ''
                            }, ${productdata?.brand_name || ''}`}
                    />
                    <meta property="og:type" content="product" />
                    <meta property="og:title" content={productdata?.name || 'Product Details'} />
                    <meta property="og:description" content={productdata?.description || 'A high-quality product'} />

                    <meta property="og:image" content={mainimage || ''} />
                    <meta property="og:url" content={canonicalUrl} />
                    {/* <link rel="canonical" href={`https://www.myacebazar.com/${canonicalUrl}`} /> */}
                    <meta property="og:site_name" content={setting?.setting?.web_name || 'My Ace Bazar'} />

                    <meta property="og:image:width" content="1200" />
                    <meta property="og:image:height" content="630" />

                    <meta name="twitter:card" content="summary_large_image" />
                    <meta name="twitter:image" content={mainimage || ''} />

                    <meta name="product:id" content={productdata?.id || ''} />
                    <meta name="product:image_link" content={mainimage || ''} />
                    <meta
                        name="product:availability"
                        content={selectedVariant && selectedVariant.stock > 0 ? 'in stock' : 'out of stock'}
                    />
                    <meta
                        name="product:price"
                        content={
                            selectedVariant
                                ? (selectedVariant?.discounted_price === 0
                                    ? selectedVariant?.price.toFixed(setting?.setting?.decimal_point || 2)
                                    : selectedVariant?.discounted_price.toFixed(setting?.setting?.decimal_point || 2))
                                : (productdata?.variants?.[0]?.discounted_price === 0
                                    ? productdata?.variants?.[0]?.price.toFixed(setting?.setting?.decimal_point || 2)
                                    : productdata?.variants?.[0]?.discounted_price.toFixed(setting?.setting?.decimal_point || 2))
                        }
                    />
                </Helmet>

            )}

            <div className={styles.productdetailsview}>
                <div className={`w-100 ${styles.breadCrumbs}`}>
                    <div className={`${styles.container} container d-flex flex-wrap align-items-center gap-2`}>
                        <div className={`${styles.breadCrumbsItem} col-12 col-sm-auto`}>
                            <Link to={"/"}>{t("home")}</Link>
                        </div>
                        {ProductCategoryList.map((category_d) => {
                            return (
                                <div className={`${styles.breadCrumbsItem} col-12 col-sm-auto`}>
                                    <span
                                        className={location.pathname.includes(category_d?.slug) ? styles.breadCrumbActive : ""}
                                        onClick={() => onClickBreadCrum(category_d)}
                                        style={{ cursor: "pointer" }} // Ensures it looks clickable
                                    >
                                        {`/ ${category_d?.name}`}
                                    </span>
                                </div>
                            )
                        })}
                    </div>
                    <div className={`${styles.backtoorderbtn}`}>
                        <button onClick={goBack}>
                            Back to Home
                        </button>
                    </div>
                </div>
                <div className={`${styles.container} container`} style={{ gap: "20px" }}>
                    <div className={`${styles.topwrapper} top-wrapper`}>
                        {product.selectedProduct_id === null || Object.keys(productdata).length === 0 ? (
                            <div className="d-flex justify-content-center">
                                <Loader width={"100%"} height={"600px"} />
                            </div>)
                            : (<div className={`row body-wrapper ${styles.ProductDetailBox}`}>
                                <div className="col-xl-5 col-lg-6 col-md-12 col-12">

                                    <div className={styles.imagewrapper}>
                                        <div className={`${styles.mainimage} col-12 border`}>
                                            <div onClick={() => handleImageClick(productdata)} style={{ cursor: "pointer" }} className={`${!show ? "" : styles.hide}`}>
                                                <ReactImageMagnify
                                                    {...{
                                                        smallImage: {
                                                            alt: 'Local Product Image',
                                                            isFluidWidth: true,
                                                            src: mainimage,
                                                        },
                                                        largeImage: {
                                                            src: mainimage,
                                                            width: 1500,
                                                            height: 1500,
                                                        },
                                                        enlargedImageContainerStyle: {
                                                            background: 'none',
                                                            zIndex: 1000,
                                                        },
                                                    }}
                                                />
                                            </div>
                                            <div className={`${styles.mainimage} col-12 border ${show ? "" : styles.hide}`}>
                                                <ReactPlayer
                                                    url={videourl}
                                                    className={`col-12 ${styles.video_player}`}
                                                    playing={false}
                                                    controls={true}
                                                    config={{
                                                        file: {
                                                            attributes: {
                                                                controlsList: 'nodownload noplaybackrate',
                                                                disablePictureInPicture: true,
                                                            }
                                                        }
                                                    }}
                                                />
                                            </div>
                                        </div>
                                        <div className={`${styles.subimagescontainer} sub-images-container`}>
                                            {images.length >= 1 ?
                                                <Slider {...settings_subImage} className={styles.imageListSlider}>
                                                    {images.map((image, index) => (
                                                        <div key={index} className={`${styles.subimage} ${mainimage === image ? styles.active : ''}`.trim()}>
                                                            <img onError={placeHolderImage} src={image} className='col-12' alt="product" onClick={() => {
                                                                setmainimage(image);
                                                                setShow(false);
                                                            }} />
                                                        </div>
                                                    ))}

                                                    {videourl !== '' && !show ?
                                                        <div className={`${styles.subvideo} border`}>
                                                            <ReactPlayer
                                                                url={videourl}
                                                                className={`col-12 ${styles.videoplayer_slide}`}
                                                                playing={false}
                                                                controls={false}
                                                                light={true}
                                                                onClick={() => setShow(true)}
                                                            />
                                                        </div>
                                                        : ""
                                                    }
                                                </Slider>
                                                :
                                                <>
                                                    {uniqueImages.map((image, index) => (
                                                        <div key={index} className={`${styles.subimage} ${mainimage === image ? styles.active : ''}`.trim()}>
                                                            <img onError={placeHolderImage} src={image} className='col-12' alt="product"
                                                                onClick={() => {
                                                                    setmainimage(image);
                                                                    setShow(false);
                                                                }}
                                                            />
                                                        </div>
                                                    ))}

                                                </>
                                            }
                                        </div>
                                    </div>
                                    {window.innerWidth > 768 && <div>
                                        {productdata?.indicator ?
                                            productdata?.indicator == 1 ?
                                                <div className={`d-flex align-items-center mt-3 ${styles.fontSize}`}>
                                                    <img src={VegIcon} alt='vegIcon' className='me-3' />
                                                    {t("vegetarian")}
                                                </div>
                                                :
                                                <div className={`d-flex align-items-center mt-3 ${styles.fontSize}`}>
                                                    <img src={NonVegIcon} alt='nonVegIcon' className='me-3' />
                                                    {t("non-vegetarian")}
                                                </div>
                                            : null}
                                        {productdata?.cancelable_status == 1 ?
                                            <div className={`d-flex align-items-center mt-3 ${styles.fontSize}`}>
                                                <img src={Cancelable} alt='cancelableIcon' className='me-3' />
                                                {t("cancelable")}
                                                {productdata?.till_status == 1 ?
                                                    t("payment_pending")
                                                    :
                                                    null
                                                }
                                                {productdata?.till_status == 2 ?
                                                    t("received")
                                                    :
                                                    null
                                                }
                                                {productdata?.till_status == 3 ?
                                                    t("processed")
                                                    :
                                                    null
                                                }
                                                {productdata?.till_status == 4 ?
                                                    t("shipped")
                                                    :
                                                    null
                                                }
                                                {productdata?.till_status == 5 ?
                                                    t("out_for_delivery")
                                                    :
                                                    null
                                                }
                                            </div>
                                            :
                                            <div className={`d-flex align-items-center mt-3 ${styles.fontSize}`}>
                                                <img src={NonCancelable} alt='nonCancelableIcon' className='me-3' />
                                                {t("non-cancelable")}
                                            </div>
                                        }
                                        {productdata?.return_status == 1 ?
                                            <div className={`d-flex align-items-center mt-3 ${styles.fontSize}`}>
                                                <img src={Returnable} alt='returnableIcon' className='me-3' />
                                                {t("returnable")} {productdata?.return_days} {t("days")}
                                            </div>
                                            :
                                            <div className={`d-flex align-items-center mt-3 ${styles.fontSize}`}>
                                                <img src={NotReturnable} alt='nonReturnableIcon' className='me-3' />
                                                {t("non-returnable")}
                                            </div>
                                        }
                                    </div>}
                                </div>
                                <div className="col-xl-7 col-lg-6 col-md-12 col-12">
                                    <div className={styles.detailwrapper}>
                                        <div className={styles.topsection}>
                                            <p className={styles.product_name}>{productdata.name}</p>
                                            {!Number(selectedVariant?.is_unlimited_stock) && selectedVariant?.status === 0 ?

                                                <p className={styles.out_of_stockText} style={{ textAlign: 'left' }}>{t("out_of_stock")}</p>
                                                : null}
                                            {/* {Object.keys(productbrand).length === 0
                                            ? null
                                            : (
                                                <div className='product-brand'>
                                                    <span className='brand-title'>{t("brand")}:</span>
                                                    <span className='brand-name' onClick={() => {
                                                        dispatch({ type: ActionTypes.SET_FILTER_BRANDS, payload: productbrand.id.toString() })
                                                        navigate('/products')
                                                    }}>
                                                        {productbrand.name}
                                                    </span>
                                                </div>
                                            )} */}
                                            <div className='d-flex flex-column gap-2 align-items-start my-1'>
                                                {selectedVariant?.discount_percentage && <div className={`${styles.specialoffer}`}>
                                                    <p>🔥Special Offer</p>
                                                </div>}
                                                <div className='d-flex align-items-center gap-4'>
                                                    <div className={`${styles.pricesection} d-flex flex-row gap-2 align-items-center my-1`}>
                                                        {setting.setting && setting.setting.currency}<p id='fa-rupee' className='m-0'>{selectedVariant ? (selectedVariant.discounted_price == 0 ? selectedVariant.price.toFixed(setting.setting && setting.setting.decimal_point) : selectedVariant.discounted_price.toFixed(setting.setting && setting.setting.decimal_point)) : (productdata.variants[0].discounted_price === 0 ? productdata.variants[0].price.toFixed(setting.setting && setting.setting.decimal_point) : productdata.variants[0].discounted_price.toFixed(setting.setting && setting.setting.decimal_point))}</p>
                                                    </div>

                                                    <div className='pt-3'>
                                                        {(selectedVariant?.price && (selectedVariant?.discounted_price !== 0)) && (selectedVariant?.price !== selectedVariant?.discounted_price) ?
                                                            <div>
                                                                <p className='fw-normal text-decoration-line-through' style={{ color: "var(--sub-text-color)", fontSize: "16px" }}>
                                                                    {setting.setting && setting.setting.currency}
                                                                    {selectedVariant?.price?.toFixed(setting.setting && setting.setting.decimal_point)}
                                                                </p>
                                                            </div>
                                                            : null}
                                                    </div>
                                                    <div className='pt-3'>
                                                        {(selectedVariant?.price && (selectedVariant?.discounted_price !== 0) && (selectedVariant?.discount_percentage !== 0)) ?
                                                            <div>
                                                                <p className='fw-normal' style={{ color: "red", fontSize: "20px" }}>
                                                                    <b>{Math.round(selectedVariant?.discount_percentage)}% Off</b>
                                                                </p>
                                                            </div>
                                                            : null}
                                                    </div>
                                                </div>
                                                <input type="hidden" id="productdetail-selected-variant-id" name="variant" value={selectedVariant ? selectedVariant.id : productdata.variants[0].id} />
                                            </div>

                                        </div>
                                        {/* <div className={styles.topsection}>
                                            <p className={styles.product_name}>{productdata.name}</p>
                                            {!Number(selectedVariant?.is_unlimited_stock) && selectedVariant?.status === 0 ?

                                                <p className={styles.out_of_stockText} style={{ textAlign: 'left' }}>{t("out_of_stock")}</p>
                                                : null} */}
                                        <div className={`${styles.bottomsection}`}>
                                            <div className={`d-flex gap-3 ${styles.bottomsectioncontent} `}>
                                                <div className={styles.variants} key={"productVariantContainer"}>

                                                    <div className={`row ${styles.rowVariants}`} key={"variants"}>
                                                        {productdata.variants.map((variant, index) => {
                                                            console.log(`Variant: ${variant.id}, Measurement: ${variant.measurement}, Cart Count: ${variant.cart_count}, Stock: ${variant.stock}`);

                                                            if (variant.measurement === 'undefined') return;

                                                            return (
                                                                <div className={`${styles.variantsection}`} key={variant?.id}>
                                                                    <div className={`${styles.variantelement} 
        ${variant_index === variant.id ? styles.active : ''}  
        ${variant.stock === 0 ? styles.out_of_stock : ''}`}
                                                                        key={index}
                                                                    >
                                                                        <label className={styles.element_container} htmlFor={`variant${index}`}>
                                                                            <div className={styles.topsectionvariant}>
                                                                                <input
                                                                                    type="radio"
                                                                                    name="variant"
                                                                                    id={`variant${index}`}
                                                                                    checked={variant_index === variant.id}
                                                                                    onChange={() => handleVariantChange(variant, variant.id)}
                                                                                />
                                                                            </div>
                                                                            <div className="h-100">
                                                                                <span className={`d-flex align-items-center flex-column ${styles.clothingSize}`}>
                                                                                    {variant.measurement} {variant.stock_unit_name}
                                                                                </span>
                                                                            </div>
                                                                        </label>
                                                                    </div>
                                                                </div>
                                                            );
                                                        })}


                                                    </div>
                                                </div>
                                                <div className={styles.cart_option}>
                                                    {selectedVariant ?
                                                        (user?.user && cart?.cartProducts?.find(prdct => prdct?.product_variant_id == selectedVariant.id)?.qty >= 1
                                                            ? <>
                                                                <div id={`input-cart-quickview`} className={`${styles.inputtocart} input-to-cart`}>
                                                                    <button type='button' onClick={() => {
                                                                        if (cart?.cartProducts?.find(prdct => prdct?.product_variant_id == selectedVariant.id)?.qty == 1) {
                                                                            removefromCart(productdata.id, selectedVariant.id);
                                                                        }
                                                                        else {
                                                                            addtoCart(productdata.id, selectedVariant.id, cart?.cartProducts?.find(prdct => prdct?.product_variant_id == selectedVariant.id)?.qty - 1);
                                                                        }

                                                                    }} className={`${styles.wishlistbutton} wishlist-button`}><BiMinus fill='#fff' /></button>
                                                                    <span id={`input-quickview`} className={styles.cardCount}>
                                                                        {
                                                                            cart?.cartProducts?.find(prdct => prdct?.product_variant_id == selectedVariant.id)?.qty
                                                                        }
                                                                    </span>
                                                                    <button type='button' onClick={() => {
                                                                        const productQuantity = getProductQuantities(cart?.cartProducts);
                                                                        if (Number(productdata.is_unlimited_stock)) {
                                                                            if (productQuantity?.find(prdct => prdct?.product_id == productdata?.id)?.qty >= Number(productdata?.total_allowed_quantity)) {
                                                                                toast.error('Apologies, maximum product quantity limit reached', { hideProgressBar: true, autoClose: 1000 });
                                                                            }
                                                                            else {
                                                                                addtoCart(productdata.id, selectedVariant.id, cart?.cartProducts?.find(prdct => prdct?.product_variant_id == selectedVariant.id)?.qty + 1);
                                                                            }
                                                                        }
                                                                        else {
                                                                            if (productQuantity?.find(prdct => prdct?.product_id == productdata?.id)?.qty >= Number(productdata?.total_allowed_quantity)) {
                                                                                toast.error('Oops, this item is out of stock.', { hideProgressBar: true, autoClose: 1000 });
                                                                            }
                                                                            else if (cart?.cartProducts?.find(prdct => prdct?.product_variant_id == selectedVariant.id)?.qty >= Number(setting.setting.max_cart_items_count)) {
                                                                                toast.error('Apologies, maximum cart quantity limit reached', { hideProgressBar: true, autoClose: 1000 });
                                                                            }
                                                                            else {
                                                                                addtoCart(productdata.id, selectedVariant.id, cart?.cartProducts?.find(prdct => prdct?.product_variant_id == selectedVariant.id)?.qty + 1);
                                                                            }
                                                                        }

                                                                    }} className={`${styles.wishlistbutton} wishlist-button`}><BsPlus fill='#fff' /> </button>
                                                                </div>
                                                            </> : <>
                                                                <button type='button' id={`Add-to-cart-quickview`} className={`${styles.Addtocartquickview} add-to-cart`}
                                                                    onClick={() => {
                                                                        const productQuantity = getProductQuantities(cart?.cartProducts);
                                                                        if (localStorage.getItem('jwt_token') !== undefined) {
                                                                            if (productQuantity?.find(prdct => prdct?.product_id == productdata?.id)?.qty >= Number(productdata?.total_allowed_quantity)) {
                                                                                toast.error('Oops, this item is out of stock.', { hideProgressBar: true, autoClose: 1000 });
                                                                            }
                                                                            else if (Number(productdata.is_unlimited_stock)) {
                                                                                addtoCart(productdata.id, selectedVariant.id, 1);
                                                                            } else {
                                                                                if (selectedVariant.status) {
                                                                                    addtoCart(productdata.id, selectedVariant.id, 1);
                                                                                    setP_id(productdata.id);
                                                                                    setP_V_id(selectedVariant.id);
                                                                                    setQnty(1);
                                                                                } else {
                                                                                    toast.error('Oops, this item is out of stock.', { hideProgressBar: true, autoClose: 1000 });
                                                                                }
                                                                            }
                                                                        }
                                                                        else {
                                                                            document.getElementById("user-profile").click()
                                                                            return;
                                                                        }
                                                                    }}>{t("add_to_cart")}</button>

                                                                {/* <button 
    type='button' 
    id={`Add-to-cart-quickview`} 
    className={`${styles.Addtocartquickviews} add-to-cart`}
    onClick={() => {
        window.location.href = "http://localhost:3000/checkout";
    }}
>
    {t("Buy Now")}
</button> */}

                                                                {/* <button type='button' id={`Add-to-cart-quickview`} className={`${styles.Addtocartquickview} add-to-cart`}
                                                                        onClick={() => onClickBuyNow(productdata)}>Buy Now</button> */}
                                                            </>)
                                                        : productdata.variants[0].cart_count >= 1 ?
                                                            <>
                                                                <div id={`input-cart-quickview`} className={`${styles.inputtocart} input-to-cart`}>
                                                                    <button type='button' onClick={() => {

                                                                        if (productdata.variants[0].cart_count === 1) {

                                                                            removefromCart(productdata.id, productdata.variants[0].id);
                                                                        }
                                                                        else {
                                                                            addtoCart(productdata.id, productdata.variants[0].id, productdata.variants[0].cart_count - 1);
                                                                            setQuantity(quantity - 1);
                                                                        }

                                                                    }} className={`${styles.wishlistbutton} wishlist-button`}><BiMinus fill='#fff' /></button>
                                                                    <span id={`input-quickview`} className={styles.cardCount}>{productdata.variants[0].cart_count}</span>
                                                                    <button type='button' onClick={() => {

                                                                        if (Number(productdata.is_unlimited_stock)) {
                                                                            if (productdata.variants[0].cart_count >= Number(setting.setting.max_cart_items_count)) {
                                                                                toast.error('Apologies, maximum product quantity limit reached', { hideProgressBar: true, autoClose: 1000 });
                                                                            }
                                                                            else {
                                                                                addtoCart(productdata.id, productdata.variants[0].id, productdata.variants[0].cart_count + 1);
                                                                            }
                                                                        }
                                                                        else {

                                                                            if (productdata.variants[0].cart_count >= Number(setting.setting.max_cart_items_count)) {
                                                                                toast.error('Apologies, maximum product quantity limit reached', { hideProgressBar: true, autoClose: 1000 });
                                                                            }
                                                                            else if (productdata.variants[0].cart_count >= Number(productdata.variants[0].stock)) {
                                                                                toast.error('OOps, Limited Stock Available', { hideProgressBar: true, autoClose: 1000 });
                                                                            }
                                                                            else {
                                                                                addtoCart(productdata.id, productdata.variants[0].id, productdata.variants[0].cart_count + 1);
                                                                            }
                                                                        }
                                                                    }} className={`${styles.wishlistbutton} wishlist-button`}><BsPlus fill='#fff' /> </button>
                                                                </div>
                                                            </> : <>

                                                                <button type='button' id={`Add-to-cart-quickview`} className={`${styles.addtocart} add-to-cart`}
                                                                    onClick={() => {
                                                                        if (localStorage.getItem('jwt_token') !== undefined) {
                                                                            if (Number(productdata.is_unlimited_stock)) {
                                                                                addtoCart(productdata.id, productdata.varinats[0].id, 1);
                                                                            } else {
                                                                                if (selectedVariant.status) {
                                                                                    addtoCart(productdata.id, productdata.variants[0].id, 1);
                                                                                    setP_id(productdata.id);
                                                                                    setP_V_id(productdata.variants[0].id);
                                                                                    setQnty(1);
                                                                                } else {
                                                                                    toast.error('OOps, Limited Stock Available', { hideProgressBar: true, autoClose: 1000 });
                                                                                }
                                                                            }
                                                                        }
                                                                        else {
                                                                            document.getElementById("user-profile").click()
                                                                            return;
                                                                        }
                                                                    }}>{t("add_to_cart")}</button>

                                                            </>}
                                                    {favorite.favorite && favorite?.favouriteProductIds?.some(id => id == productdata.id) ? (
                                                        <button type="button" className={`${styles.wishlistproduct} wishlist-product w-180 h-180`} onClick={() => {
                                                            if (localStorage.getItem('jwt_token') !== undefined) {
                                                                removefromFavorite(productdata.id);
                                                            } else {
                                                                toast.error(t('required_login_message_for_cart', { hideProgressBar: true, autoClose: 1000 }));
                                                            }
                                                        }}
                                                        >
                                                            <BsHeartFill size={19} fill='green' />
                                                        </button>)
                                                        : (
                                                            <button key={productdata.id} type="button" className={`${styles.wishlistproduct} wishlist-product w-180 h-180`} onClick={() => {
                                                                if (localStorage.getItem('jwt_token') !== undefined) {
                                                                    addToFavorite(productdata.id);
                                                                } else {
                                                                    document.getElementById("user-profile").click()
                                                                    return;
                                                                }
                                                            }}>
                                                                <BsHeart size={19} /></button>
                                                        )}
                                                </div>

                                                <Row className={styles.inputCss}>
                                                    <Col>
                                                        <Input
                                                            ref={inputRef}
                                                            allowClear
                                                            placeholder="Enter your Pincode"
                                                            prefix={<EnvironmentOutlined />}
                                                            value={pincode}
                                                            onChange={handleChange}
                                                            maxLength={6}
                                                            style={{ width: "200px", height: '33px' }}
                                                            className={styles.pincode}
                                                        />
                                                    </Col>
                                                    <Col>
                                                        <Button onClick={onClickCheck}>Check</Button>
                                                    </Col>
                                                </Row>

                                                <div><p className={`fw-normal ${styles.deliveryp}`}>{pincodetext}</p></div>
                                            </div>

                                            {productdata?.fssai_lic_no &&
                                                <div className={styles.fssaidetails}>
                                                    <div className={`${styles.imagecontainer} image-container`}>
                                                        <img src={productdata?.fssai_lic_img} alt='fssai' />
                                                    </div>
                                                    <div className={`${styles.fssailicenseno} fssai-license-no`}>
                                                        <span>
                                                            {`${t('license_no')} : ${productdata.fssai_lic_no}`}
                                                        </span>
                                                    </div>
                                                </div>
                                            }
                                            {productdata?.brand_name ?
                                                <div className={`${styles.productoverview} product-overview`}>
                                                    <div className={`${styles.productseller} product-seller`} onClick={() => onClickDetailsBrand(productdata)}>
                                                        <span className={`${styles.sellertitle} seller-title`} >{t("brand")}:</span>
                                                        <span className={`${styles.sellername} seller-name`}>{productdata?.brand_name} </span>
                                                    </div>
                                                    {/* {productdata.tags !== "" ? (

                                                <div className='product-tags'>
                                                    <span className='tag-title'>{t("product_tags")}:</span>
                                                    <span className='tag-name'>{productdata.tags} </span>
                                                </div>
                                            ) : ""} */}
                                                </div> : null}
                                            {window.innerWidth < 768 && <div>
                                                {productdata?.indicator ?
                                                    productdata?.indicator == 1 ?
                                                        <div className={`d-flex align-items-center mt-3 ${styles.fontSize}`}>
                                                            <img src={VegIcon} alt='vegIcon' className='me-3' />
                                                            {t("vegetarian")}
                                                        </div>
                                                        :
                                                        <div className={`d-flex align-items-center mt-3 ${styles.fontSize}`}>
                                                            <img src={NonVegIcon} alt='nonVegIcon' className='me-3' />
                                                            {t("non-vegetarian")}
                                                        </div>
                                                    : null}
                                                {productdata?.cancelable_status == 1 ?
                                                    <div className={`d-flex align-items-center mt-3 ${styles.fontSize}`}>
                                                        <img src={Cancelable} alt='cancelableIcon' className='me-3' />
                                                        {t("cancelable")}
                                                        {productdata?.till_status == 1 ?
                                                            t("payment_pending")
                                                            :
                                                            null
                                                        }
                                                        {productdata?.till_status == 2 ?
                                                            t("received")
                                                            :
                                                            null
                                                        }
                                                        {productdata?.till_status == 3 ?
                                                            t("processed")
                                                            :
                                                            null
                                                        }
                                                        {productdata?.till_status == 4 ?
                                                            t("shipped")
                                                            :
                                                            null
                                                        }
                                                        {productdata?.till_status == 5 ?
                                                            t("out_for_delivery")
                                                            :
                                                            null
                                                        }
                                                    </div>
                                                    :
                                                    <div className={`d-flex align-items-center mt-3 ${styles.fontSize}`}>
                                                        <img src={NonCancelable} alt='nonCancelableIcon' className='me-3' />
                                                        {t("non-cancelable")}
                                                    </div>
                                                }
                                                {productdata?.return_status == 1 ?
                                                    <div className={`d-flex align-items-center mt-3 ${styles.fontSize}`}>
                                                        <img src={Returnable} alt='returnableIcon' className='me-3' />
                                                        {t("returnable")} {productdata?.return_days} {t("days")}
                                                    </div>
                                                    :
                                                    <div className={`d-flex align-items-center mt-3 ${styles.fontSize}`}>
                                                        <img src={NotReturnable} alt='nonReturnableIcon' className='me-3' />
                                                        {t("non-returnable")}
                                                    </div>
                                                }
                                            </div>}
                                            {productRating?.rating_list?.length !== 0 ?
                                                <div className={`mt-3 ${styles.cursorPointer}`}>
                                                    <OverlayTrigger
                                                        trigger="click"
                                                        placement="bottom-start"
                                                        overlay={popover}
                                                        rootClose={true}
                                                        style={{ paddingBottom: '10px' }}
                                                    >

                                                        {/* {console.log(productRating)} */}
                                                        <div className={`${styles.ratings} d-flex align-items-center`}>
                                                            {/* Render the stars */}
                                                            {[...Array(5)].map((_, index) => {
                                                                // Determine if the current index is a full star, half star, or empty star
                                                                if (index < Math.floor(productRating?.average_rating)) {
                                                                    // Full star
                                                                    return (
                                                                        <LuStar
                                                                            key={index}
                                                                            className='me-2'
                                                                            style={{
                                                                                fill: "#fead0e", // Yellow for filled stars
                                                                                stroke: "#fead0e" // Yellow stroke for filled stars
                                                                            }}
                                                                        />
                                                                    );
                                                                } else if (index === Math.floor(productRating?.average_rating) && productRating?.average_rating % 1 !== 0) {
                                                                    // Half star
                                                                    return (
                                                                        <LuStar
                                                                            key={index}
                                                                            className='me-2'
                                                                            style={{
                                                                                position: 'relative',
                                                                                width: '1em',
                                                                                height: '1em',
                                                                                clipPath: 'inset(0 50% 0 0)', // Clip the right half
                                                                                fill: "#fead0e", // Yellow for the left half
                                                                                stroke: "#fead0e" // Yellow stroke for the left half
                                                                            }}
                                                                        >
                                                                            <LuStar
                                                                                style={{
                                                                                    position: 'absolute',
                                                                                    left: 0,
                                                                                    width: '100%',
                                                                                    height: '100%',
                                                                                    fill: "#9AA6B2", // Gray for the right half
                                                                                    stroke: "#9AA6B2" // Gray stroke for the right half
                                                                                }}
                                                                            />
                                                                        </LuStar>
                                                                    );
                                                                } else {
                                                                    // Empty star
                                                                    return (
                                                                        <LuStar
                                                                            key={index}
                                                                            className='me-2'
                                                                            style={{
                                                                                fill: "#9AA6B2", // Gray for unfilled stars
                                                                                stroke: "#9AA6B2" // Gray stroke for unfilled stars
                                                                            }}
                                                                        />
                                                                    );
                                                                }
                                                            })}

                                                            {/* Display the average rating */}
                                                            <div className={`${styles.borderend} border-end border-2 pe-2 me-2 ${styles.avgRating}`}>
                                                                {productRating?.average_rating?.toFixed(setting.setting && setting.setting.decimal_point)}
                                                            </div>

                                                            {/* Display the total ratings */}
                                                            <div style={{ marginLeft: '12px' }}>
                                                                {totalData} Ratings
                                                            </div>
                                                        </div>
                                                    </OverlayTrigger>
                                                </div> : null}
                                            {/* {productdata?.indicator ?
                                                productdata?.indicator == 1 ?
                                                    <div className={`d-flex align-items-center mt-3 ${styles.fontSize}`}>
                                                        <img src={VegIcon} alt='vegIcon' className='me-3' />
                                                        {t("vegetarian")}
                                                    </div>
                                                    :
                                                    <div className={`d-flex align-items-center mt-3 ${styles.fontSize}`}>
                                                        <img src={NonVegIcon} alt='nonVegIcon' className='me-3' />
                                                        {t("non-vegetarian")}
                                                    </div>
                                                : null}
                                            {productdata?.cancelable_status == 1 ?
                                                <div className={`d-flex align-items-center mt-3 ${styles.fontSize}`}>
                                                    <img src={Cancelable} alt='cancelableIcon' className='me-3' />
                                                    {t("cancelable")}
                                                    {productdata?.till_status == 1 ?
                                                        t("payment_pending")
                                                        :
                                                        null
                                                    }
                                                    {productdata?.till_status == 2 ?
                                                        t("received")
                                                        :
                                                        null
                                                    }
                                                    {productdata?.till_status == 3 ?
                                                        t("processed")
                                                        :
                                                        null
                                                    }
                                                    {productdata?.till_status == 4 ?
                                                        t("shipped")
                                                        :
                                                        null
                                                    }
                                                    {productdata?.till_status == 5 ?
                                                        t("out_for_delivery")
                                                        :
                                                        null
                                                    }
                                                </div>
                                                :
                                                <div className={`d-flex align-items-center mt-3 ${styles.fontSize}`}>
                                                    <img src={NonCancelable} alt='nonCancelableIcon' className='me-3' />
                                                    {t("non-cancelable")}
                                                </div>
                                            }
                                            {productdata?.return_status == 1 ?
                                                <div className={`d-flex align-items-center mt-3 ${styles.fontSize}`}>
                                                    <img src={Returnable} alt='returnableIcon' className='me-3' />
                                                    {t("returnable")} {productdata?.return_days} {t("days")}
                                                </div>
                                                :
                                                <div className={`d-flex align-items-center mt-3 ${styles.fontSize}`}>
                                                    <img src={NotReturnable} alt='nonReturnableIcon' className='me-3' />
                                                    {t("non-returnable")}
                                                </div>
                                            } */}
                                            <div className={`${styles.shareproductcontainer} share-product-container`}>
                                                <span>{t("share_product")}:</span>
                                                <ul className={styles.shareproduct}>
                                                    <li className={`${styles.shareproducticon}`}><div onClick={() => handleShareClick("whatsapp")}><WhatsappIcon size={32} round={true} /></div></li>
                                                    <li className={styles.shareproducticon}><div onClick={() => handleShareClick("telegram")}><TelegramIcon size={32} round={true} /> </div></li>
                                                    <li className={styles.shareproducticon}><div onClick={() => handleShareClick("facebook")}><FacebookIcon size={32} round={true} /> </div></li>
                                                    <li className={styles.shareproducticon}>
                                                        <button type='button' onClick={() => {
                                                            navigator.clipboard.writeText(`${setting.setting && setting.setting.web_settings.website_url}product/${productdata.slug}`);
                                                            toast.success("Copied Succesfully!!", { hideProgressBar: true, autoClose: 1000 });
                                                        }} > <BiLink size={30} /></button>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            )}

                    </div>

                    <ProductDetailsTabs
                        productdata={productdata}
                        productRating={productRating}
                        totalData={totalData}
                        loading={Loading}
                        ratingImages={ratingImages}
                        totalImages={totalImages}
                    />

                    <div className={styles.relatedproductwrapper}>
                        <h5>{t("related_product")}</h5>
                        <div className={styles.relatedproductcontainer}>
                            {relatedProducts === null
                                ? <div className="d-flex justify-content-center">
                                    <Loader width={"100%"} height={"600px"} />
                                </div>
                                :
                                <div className="row">
                                    <Slider {...settings}>
                                        {relatedProducts.map((related_product, index) => {
                                            const handleShareClick = (platform) => {
                                                const shareUrl = `${setting.setting && setting.setting.web_settings.website_url}/product/${related_product.slug}`;
                                                let redirectUrl = "";
                                                const isDesktop = window.innerWidth > 768;
                                                switch (platform) {
                                                    case "whatsapp":
                                                        redirectUrl = isDesktop
                                                            ? `https://web.whatsapp.com/send?text=${encodeURIComponent(shareUrl)}`
                                                            : `https://api.whatsapp.com/send?text=${encodeURIComponent(shareUrl)}`;
                                                        break;
                                                    case "telegram":
                                                        redirectUrl = `https://t.me/share/url?url=${encodeURIComponent(shareUrl)}`;
                                                        break;
                                                    case "facebook":
                                                        redirectUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl)}`;
                                                        break;
                                                    default:
                                                        return;
                                                }
                                                window.open(redirectUrl, "_blank", "noopener,noreferrer");
                                            };
                                            const handleVariantSelect = (e, pid) => {
                                                const selected = related_product.variants.find(variant => variant.id === e.target.value);
                                                setSelectedItemSize(prevState => ({
                                                    ...prevState,
                                                    [pid]: selected,
                                                }));

                                                setShowDropdown(prevState => ({
                                                    ...prevState,
                                                    [pid]: false,
                                                }));
                                            }

                                            return (
                                                <div className="col-md-3 col-lg-4" key={related_product?.id}>
                                                    <div className={`${styles.productcard} product-card`}>
                                                        <span className={`border border-light rounded-circle p-2 px-3 ${styles.aiEye}`} onClick={() => {
                                                            setShowModal(true);
                                                            setselectedProduct(related_product);
                                                            setP_id(related_product.id); setP_V_id(related_product.variants[0].id); setQnty(related_product.variants[0].cart_count + 1);
                                                        }} >
                                                            <AiOutlineEye fill='black'
                                                            />
                                                        </span>
                                                        <Link to={`/product/${related_product.slug}`} target="_blank"
                                                            rel="noopener noreferrer">
                                                            <div className={`${styles.imagecontainer} image-container`} >

                                                                <img onError={placeHolderImage} src={related_product.image_url} alt={related_product.slug} className='card-img-top' onClick={() => {
                                                                    navigate(`/product/${related_product.slug}`);
                                                                    window.scrollTo({ top: 0, behavior: "smooth" });
                                                                    // dispatch({ type: ActionTypes.SET_SELECTED_PRODUCT, payload: related_product.id });
                                                                    dispatch(setSelectedProduct({ data: related_product.id }));
                                                                    getProductDatafromApi();

                                                                }} />
                                                                {!Number(related_product.is_unlimited_stock) && related_product.variants[0].status === 0 &&
                                                                    <div className={styles.out_of_stockOverlay}>
                                                                        <p className={styles.out_of_stockText}>{t("out_of_stock")}</p>
                                                                    </div>
                                                                }
                                                            </div>
                                                        </Link>

                                                        <div className={`d-flex flex-column justify-content-end card-body ${styles.productcardbody} product-card-body p-3`} onClick={() => {
                                                            dispatch(setSelectedProduct({ data: related_product.id }));
                                                            setSelectedVariant(null);
                                                            setQuantity(0);
                                                            getProductDatafromApi();
                                                            window.open(`/product/${related_product.slug}`, "_blank", "noopener,noreferrer");
                                                        }} >
                                                            {related_product?.rating_count > 0 ? <div className={`${styles.ratings} d-flex align-items-center product-card-rating-content`} style={{ fontSize: "14px" }}>
                                                                <LuStar className='me-2' style={{ fill: "#fead0e", stroke: "#fead0e" }} />
                                                                <LuStar className='me-2' style={{ fill: "#fead0e", stroke: "#fead0e" }} />
                                                                <LuStar className='me-2' style={{ fill: "#fead0e", stroke: "#fead0e" }} />
                                                                <LuStar className='me-2' style={{ fill: "#fead0e", stroke: "#fead0e" }} />
                                                                <LuStar className='me-2' style={{ fill: "#fead0e", stroke: "#fead0e" }} />
                                                                <div className={`border-end border-2 pe-2 me-2 ${styles.avgRating}`}>
                                                                    {related_product?.average_rating?.toFixed(setting.setting && setting.setting.decimal_point)}
                                                                </div>
                                                                <div>
                                                                    {related_product?.rating_count}
                                                                </div>
                                                            </div> : null}
                                                            {product?.brand_name && <div className={`${styles.brandName} d-flex align-items-center`} onClick={(e) => onClickBrand(e, related_product)} title={product?.brand_name}>{truncateBrandName(product?.brand_name)}</div>}
                                                            <h3 style={{ textTransform: "capitalize" }} onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>{related_product.name}</h3>

                                                            {/* <p id='relatedproduct-fa-rupee2' className='m-0'>
                                                                {setting.setting && setting.setting.currency}
                                                                {related_product.variants[0].discounted_price === 0 ? related_product.variants[0].price.toFixed(setting.setting && setting.setting.decimal_point) : related_product.variants[0].discounted_price.toFixed(setting.setting && setting.setting.decimal_point)}
                                                            </p> */}
                                                            <div className={styles.price}>

                                                                <span id={`price${index}-section`} className="d-flex align-items-center">
                                                                    <p id='relatedproduct-fa-rupee' className='m-0'>
                                                                        {setting.setting && setting.setting.currency}
                                                                        {related_product.variants[0].discounted_price === 0 ? related_product.variants[0].price.toFixed(setting.setting && setting.setting.decimal_point) : related_product.variants[0].discounted_price.toFixed(setting.setting && setting.setting.decimal_point)}
                                                                    </p>
                                                                    {(related_product?.variants[0]?.price && (related_product?.variants[0]?.discounted_price != 0)) && (related_product?.variants[0]?.price !== related_product?.variants[0]?.discounted_price) ?
                                                                        <span id={`price${index}-section`} className="d-flex align-items-center" >
                                                                            <p id='relatedproduct-fa-rupee' className='fw-normal text-decoration-line-through m-0' style={{ color: "var(--sub-text-color)", fontSize: "14px" }}>{setting.setting && setting.setting.currency}
                                                                                {related_product?.variants[0]?.price?.toFixed(setting.setting && setting.setting.decimal_point)}
                                                                            </p>
                                                                        </span>
                                                                        : null}

                                                                </span>
                                                            </div>
                                                            <div className={styles.product_varients_drop} onClick={(e) => e.stopPropagation()} >
                                                                {related_product.variants.length > 1 && <>
                                                                    <div className={`${styles.variant_selection} ${showDropdown[related_product?.id] ? styles.active : ""}`} onClick={(e) => e.stopPropagation()}>
                                                                        <span>
                                                                            Size: {selectedItemSize[related_product?.id]?.measurement || related_product?.variants[0].measurement}
                                                                        </span>
                                                                        <IoIosArrowDown onClick={(e) => {
                                                                            e.stopPropagation();
                                                                            setShowDropdown(prevState => ({
                                                                                ...prevState,
                                                                                [related_product?.id]: !prevState[related_product?.id],
                                                                            }))
                                                                        }
                                                                        } />
                                                                    </div>
                                                                </>}
                                                                <Modal
                                                                    title="Select Variant"
                                                                    open={!!showDropdown[related_product?.id]}
                                                                    onCancel={() => setShowDropdown(prevState => ({
                                                                        ...prevState,
                                                                        [related_product?.id]: false,
                                                                    }))}
                                                                    footer={null}
                                                                    mask={false}
                                                                    width={350}
                                                                    style={{ top: "30%" }}
                                                                >
                                                                    <Radio.Group
                                                                        onChange={(e) => {
                                                                            e.stopPropagation();
                                                                            handleVariantSelect(e, related_product?.id);
                                                                        }}
                                                                        value={selectedItemSize[related_product?.id]?.id || related_product?.variants[0]?.id}
                                                                    >
                                                                        {related_product.variants.map((variant) => (
                                                                            <Radio key={variant.id} value={variant.id} style={{ display: "block", marginBottom: 10 }} onClick={(e) => e.stopPropagation()}>
                                                                                {variant.measurement} {variant.stock_unit_name}
                                                                            </Radio>
                                                                        ))}
                                                                    </Radio.Group>
                                                                </Modal>
                                                            </div>
                                                        </div>

                                                        <div className={`d-flex flex-row border-top ${styles.productcardfooter} product-card-footer`}>
                                                            <div className='border-end'>
                                                                {favorite.favorite && favorite.favorite.data.some(element => element.id === related_product.id) ? (
                                                                    <button type="button" className={`${styles.wishlistproduct} wishlist-product w-200 h-200`} onClick={() => {
                                                                        if (localStorage.getItem('jwt_token') !== undefined) {
                                                                            removefromFavorite(related_product.id);
                                                                        } else {
                                                                            toast.error(t('required_login_message_for_cart', { hideProgressBar: true, autoClose: 1000 }));
                                                                        }
                                                                    }}>
                                                                        <BsHeartFill size={19} fill='green' />
                                                                    </button>
                                                                ) : (
                                                                    <button key={related_product.id} type="button" className={`${styles.wishlistproduct} wishlist-product w-200 h-200`} onClick={() => {
                                                                        if (localStorage.getItem('jwt_token') !== undefined) {
                                                                            addToFavorite(related_product.id);
                                                                        } else {
                                                                            toast.error(t("required_login_message_for_cart", { hideProgressBar: true, autoClose: 1000 }));
                                                                        }
                                                                    }}>
                                                                        <BsHeart size={19} />
                                                                    </button>
                                                                )}
                                                            </div>
                                                            <div className='border-end' style={{ flexGrow: "1" }} >
                                                                {user?.user && cart?.cartProducts?.find(prdct => prdct?.product_variant_id === (selectedItemSize[related_product?.id]?.id || related_product.variants[0].id))?.qty > 0 ? (
                                                                    <div id={`input-cart-productdetail`} className={`${styles.inputtocart} input-to-cart`}>
                                                                        <button type='button' className={`${styles.wishlistbutton} wishlist-button`} onClick={() => {
                                                                            if (related_product.variants[0].cart_count === 1) {
                                                                                removefromCart(related_product.id, (selectedItemSize[related_product?.id]?.id || related_product.variants[0].id));
                                                                            } else {
                                                                                addtoCart(related_product.id, (selectedItemSize[related_product?.id]?.id || related_product.variants[0].id), cart?.cartProducts?.find(
                                                                                    (prdct) =>
                                                                                        prdct?.product_variant_id ==
                                                                                        (selectedItemSize[related_product?.id]?.id || related_product.variants[0].id)
                                                                                )?.qty - 1);
                                                                            }
                                                                        }}>
                                                                            <BiMinus size={19} fill='#fff' />
                                                                        </button>
                                                                        <div className="quantity-container text-center">
                                                                            <input
                                                                                type="number"
                                                                                min="1"
                                                                                max={related_product.variants[0].stock}
                                                                                className="quantity-input bg-transparent text-center"
                                                                                value={cart?.cartProducts?.find(prdct => prdct?.product_variant_id === (selectedItemSize[related_product?.id]?.id || related_product.variants[0].id))?.qty}
                                                                                onChange={(e) => {
                                                                                    setQuantity(parseInt(e.target.value));
                                                                                }}
                                                                                disabled
                                                                            />
                                                                        </div>
                                                                        <button type='button' className={`${styles.wishlistbutton} wishlist-button`} onClick={() => {
                                                                            if (related_product.variants[0].cart_count < Number(setting.setting.max_cart_items_count)) {
                                                                                addtoCart(related_product.id, (selectedItemSize[related_product?.id]?.id || related_product.variants[0].id), cart?.cartProducts?.find(
                                                                                    (prdct) =>
                                                                                        prdct?.product_variant_id ==
                                                                                        (selectedItemSize[related_product?.id]?.id || related_product.variants[0].id)
                                                                                )?.qty + 1);
                                                                            } else {
                                                                                toast.error('Apologies, maximum product quantity limit reached!', { hideProgressBar: true, autoClose: 1000 });
                                                                            }

                                                                        }}>
                                                                            <BsPlus size={19} fill='#fff' />
                                                                        </button>
                                                                    </div>
                                                                ) : (
                                                                    <button type="button" id={`Add-to-cart-section${index}`} className={`w-100 h-100 ${styles.addtocart} add-to-cart active ${(!Number(related_product.is_unlimited_stock) && (related_product.variants[0].stock <= 0)) ? styles.buttonDisabled : ""}`} onClick={() => {
                                                                        if (localStorage.getItem('jwt_token') !== undefined) {
                                                                            // Check if the cart is properly defined
                                                                            if (cart && cart.cart && cart.cart.data && cart.cart.data.cart && cart.cart.data.cart.some(element => element.product_id === related_product.id) && cart.cart.data.cart.some(element => element.product_variant_id === related_product.variants[0].id)) {
                                                                                toast.info('Product already in Cart', { hideProgressBar: true, autoClose: 1000 });
                                                                            } else {
                                                                                if (Number(related_product.variants[0].stock) > 1) {
                                                                                    addtoCart(related_product.id, (selectedItemSize[related_product?.id]?.id || related_product.variants[0].id), 1);
                                                                                } else {
                                                                                    toast.error(t("out_of_stock_message", { hideProgressBar: true, autoClose: 1000 }));
                                                                                }
                                                                            }
                                                                        } else {
                                                                            toast.error("OOps! You need to login first to access the cart!", { hideProgressBar: true, autoClose: 1000 });
                                                                        }
                                                                    }} disabled={!Number(related_product.is_unlimited_stock) && related_product.variants[0].stock <= 0}>{t("add_to_cart")}</button>
                                                                )}
                                                            </div>

                                                            <div className='dropup share'>
                                                                <button type="button" className='w-200 h-200 ' data-bs-toggle="dropdown" aria-expanded="false">
                                                                    <BsShare size={22} />
                                                                </button>
                                                                <ul className={`${styles.dropdownmenu} dropdown-menu`}>
                                                                    <li className={`${styles.dropDownLi} dropDownLi`}><div onClick={() => handleShareClick("whatsapp")} ><WhatsappIcon size={32} round={true} /><span>WhatsApp</span></div></li>
                                                                    <li className={`${styles.dropDownLi} dropDownLi`}><div onClick={() => handleShareClick("telegram")}><TelegramIcon size={32} round={true} /> <span>Telegram</span></div></li>
                                                                    <li className={`${styles.dropDownLi} dropDownLi`}><div onClick={() => handleShareClick("facebook")}><FacebookIcon size={32} round={true} /><span>Facebook</span> </div></li>
                                                                    <li>
                                                                        <button type='button' onClick={() => {
                                                                            navigator.clipboard.writeText(`${setting.setting && setting.setting.web_settings.website_url}product/${related_product.slug}`);
                                                                            toast.success("Copied Succesfully!!", { hideProgressBar: true, autoClose: 1000 });
                                                                        }} className="react-share__ShareButton">
                                                                            <BiLink size={30} /> <span>{("TapToCopy")}</span>
                                                                        </button>
                                                                    </li>
                                                                </ul>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                            )
                                        })}
                                    </Slider>
                                </div>

                            }

                        </div>
                    </div>
                    {/* login modal */}
                    <ImageQuickViewModal selectedProduct={selectedProduct} setselectedProduct={setselectedProduct} showModal={imageShowModal} setShowModal={setImageShowModal} setP_V_id={setP_V_id} setP_id={setP_id} />
                    <QuickViewModal selectedProduct={selectedProduct} setselectedProduct={setselectedProduct} showModal={showModal} setShowModal={setShowModal} setP_V_id={setP_V_id} setP_id={setP_id} />
                    <Popup product_id={p_id} product_variant_id={p_v_id} quantity={qnty} cookies={cookies} toast={toast} city={city} />
                </div>

            </div >
        </>

    );
};

export default ProductDetails;